import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Lang from "./SyncSettingsLang";
import "./syncsettings.scss";
import * as actions from "states/appState";

import Input from "_modules/input/Input";
import Button from "_modules/button/Button";
import ButtonSave from "components/button-save/ButtonSave";
import * as validation from "utils/validation";

class View extends Component {

    constructor(props) {
        super(props);

        this.state = {
            initial_incident_download_months: "",
            offline_incident_retention_months: "",
            errors: {},
        }
    }

    componentWillMount() {
        this.populate(this.props);
    }

    componentWillReceiveProps(nextProps) {
        // repopulate only when a new settings document arrives; every dispatch
        // creates a new appState, so populating on each one would overwrite the
        // user's unsaved input on every keystroke
        if (nextProps.appState.syncSettings !== this.props.appState.syncSettings) {
            this.populate(nextProps);
        }
    }

    populate = (props) => {
        const settings = props.appState.syncSettings;
        if (settings) {
            this.setState({
                initial_incident_download_months: settings.initial_incident_download_months,
                offline_incident_retention_months: settings.offline_incident_retention_months,
            })
        }
    }

    onFieldChange = (params, ev) => {
        // Input passes its instance; nameID identifies which field changed
        this.setState({
            [params.props.nameID]: ev.target.value,
        })
        this.props.actions.toggleSave(true);
    }

    retryLoad = (param) => {
        this.props.actions.getSyncSettings();
    }

    save = (param) => {
        const errors = {
            initial_incident_download_months: !validation.isPositiveInteger(this.state.initial_incident_download_months),
            offline_incident_retention_months: !validation.isPositiveInteger(this.state.offline_incident_retention_months),
        };

        if (errors.initial_incident_download_months || errors.offline_incident_retention_months) {
            this.setState({ errors });
            return;
        }

        this.setState({ errors: {} });
        this.props.actions.saveSyncSettings({
            initial_incident_download_months: this.state.initial_incident_download_months,
            offline_incident_retention_months: this.state.offline_incident_retention_months,
        });
    }

    render() {
        const errors = this.state.errors;
        const settingsErrors = this.props.appState.errors.syncSettings;
        const saveError = settingsErrors && settingsErrors.save;
        const conflictError = settingsErrors && settingsErrors.conflict;

        // settings could not be loaded during initialization: offer a retry
        // instead of the form
        if (!this.props.appState.syncSettings) {
            return (
                <div className="syncsettings">
                    <div className="title">{Lang.TITLE}</div>
                    <div className="cnt">
                        <div className="error-message">{Lang.ERROR_LOAD}</div>
                        <Button className="button retry" label={Lang.BTN_RETRY} onClick={this.retryLoad} />
                    </div>
                </div>
            )
        }

        return (
            <div className="syncsettings">
                <div className="title">{Lang.TITLE}</div>
                <div className="cnt">
                    <div className="subtitle">{Lang.SUBTITLE}</div>

                    <div className="field">
                        <Input type="number" nameID="initial_incident_download_months" className="input"
                            label={Lang.LABEL_INITIAL_DOWNLOAD}
                            value={this.state.initial_incident_download_months}
                            error={errors.initial_incident_download_months === true}
                            onChange={this.onFieldChange} />
                        {errors.initial_incident_download_months ?
                            <div className="error-message">{Lang.ERROR_POSITIVE_INTEGER}</div>
                            : null}
                    </div>

                    <div className="field">
                        <Input type="number" nameID="offline_incident_retention_months" className="input"
                            label={Lang.LABEL_RETENTION}
                            value={this.state.offline_incident_retention_months}
                            error={errors.offline_incident_retention_months === true}
                            onChange={this.onFieldChange} />
                        {errors.offline_incident_retention_months ?
                            <div className="error-message">{Lang.ERROR_POSITIVE_INTEGER}</div>
                            : null}
                    </div>

                    {saveError ?
                        <div className="error-message">{Lang.ERROR_SAVE}</div>
                        : null}
                    {conflictError ?
                        <div className="error-message">{Lang.ERROR_CONFLICT}</div>
                        : null}
                </div>

                {this.props.appState.save ?
                    <div className="save">
                        <ButtonSave onClick={this.save} />
                    </div>
                    : null}
            </div>
        )
    }
}

export default connect(
    state => state,
    dispatch => ({
        actions: bindActionCreators(actions, dispatch),
    })
)(View);
